<template>
  <div>
    <div v-loading="loading">
      <div v-if="!loading">
        <div v-if="petList.length > 0" class="pet-container">
          <div v-for="item in petList" :key="item.petSeq">
            <el-form-item>
              <el-card class="pet-card">
                <template #header>
                  {{ item.postdate }}<br>
                  <div class="comment-container" :class="{ 'scrollable': isContentLong(item.petname + '　' + item.age + '　' + item.seibetsu) }">
                    {{ item.petname }}　{{ item.age }}　{{ item.seibetsu }}
                  </div>
                  <div class="comment-container" :class="{ 'scrollable': isContentLong(item.shumi) }">
                    趣味：{{ item.shumi }}
                  </div>
                  <div class="comment-container" :class="{ 'scrollable': isContentLong(item.imgcommnet) }">
                    コメント：{{ item.imgcommnet }}
                  </div>
                </template>
                <img
                  :src="item.imgurl"
                  class="pet-image clickable-img"
                  @click="$emit('img-click', item.imgurl)"
                />
              </el-card>
            </el-form-item>
          </div>
        </div>
        <div v-else><br>データがありません</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pet',
  props: {
    petList: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.checkContentLength();
    });
  },
  methods: {
    checkContentLength() {
      const containers = document.querySelectorAll('.comment-container');
      containers.forEach(container => {
        const content = container.innerText;
        if (this.isContentLong(content)) {
          container.classList.add('scrollable');
        }
      });
    },
    isContentLong(content) {
      if (!content) return false;
      const temp = document.createElement('span');
      temp.style.visibility = 'hidden';
      temp.style.whiteSpace = 'nowrap';
      temp.innerText = content;
      document.body.appendChild(temp);
      const width = temp.offsetWidth;
      document.body.removeChild(temp);
      return width > 350;
    }
  }
};
</script>

<style scoped>
  .pet-container {
      display: flex;                  /* 横並び */
      flex-wrap: wrap;                /* 必要に応じて折り返し */
  }
  .pet-card {
    display: flex;                    /* 内部コンテンツをフレックスボックスとして表示 */
    flex-direction: column;           /* 子要素を上から下へ配置 */
    justify-content: space-between;   /* 子要素を均等に配置 */
    overflow: hidden;                 /* コンテンツがカードの境界を超えないように制限 */
    width: 100%;                      /* カードの幅を画面に適応させる */
  }
  @media screen and (min-width: 768px) {
    .pet-card {
      width: 388.4548px;              /* 大画面での表示を正常に保つため、388pxを超えない */
    }
  }
  .pet-image {
    width: 100%;
    height: 200px;
    object-fit: contain;              /* 画像の比率を保持 */
  }
  .clickable-img {
    cursor: pointer;
    transition: box-shadow 0.2s;
  }
  .clickable-img:hover {
    box-shadow: 0 0 8px #409eff;
  }
  .comment-container {
    height: 2.5em;                    /* 一行の固定高さ */
    overflow: hidden;                 /* はみ出し部分を非表示 */
    word-break: break-all;
  }
  .scrollable {
    overflow-y: auto;                 /* 縦スクロール */
    padding-right: 14px;              /* スクロールバーのスペース */
  }
  .scrollable::-webkit-scrollbar {
    width: 14px;                      /* スクロールバーの幅 */
  }
  .scrollable::-webkit-scrollbar-thumb {
    background-color: #dcdfe6;      /* より柔らかい色 */
    border-radius: 4px;
  }
  .scrollable::-webkit-scrollbar-track {
    background: #f5f7fa;
    border-radius: 4px;
  }
  /* スクロールボタンのスタイル */
  .scrollable::-webkit-scrollbar-button {
    display: block;
    height: 14px;
    width: 14px;
    background-color: #f5f7fa;
    border: 1px solid #dcdfe6;
  }
  /* 上矢印 */
  .scrollable::-webkit-scrollbar-button:vertical:decrement {
    border-bottom: 4px solid #909399;
  }
  /* 下矢印 */
  .scrollable::-webkit-scrollbar-button:vertical:increment {
    border-top: 4px solid #909399;
  }
  /* ホバー効果 */
  .scrollable::-webkit-scrollbar-button:hover {
    background-color: #ebeef5;
  }
  /* モバイル対応 */
  @media screen and (max-width: 768px) {
    .comment-container {
      font-size: 14px;
      padding-right: 15px;
    }
  }
</style>